/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import {
	Directive,
	effect,
	input,
	type OnDestroy
} from "@angular/core";
import { FloatingElement } from "../floating-element.directive";
import { TooltipComponent } from "./tooltip/tooltip.component";

@Directive({
	selector: "[cbTooltip]",
	standalone: false,
})
export class TooltipDirective
	extends FloatingElement<TooltipComponent>
	implements OnDestroy {

	public override trigger = input<"hover" | "focus" | "click" | "contextmenu" | "none">("hover", { alias: "tooltipTrigger" });

	/**
	 * The content of the tooltip.
	 */
	/* @Input("cbTooltip") public set content(value: string) {
		this._content = value;
		this.setComponentProperties();
	} */
	public readonly content = input<string>("", { alias: "cbTooltip" });

	/**
	 * The position of the floating element.
	 */
	public override readonly position = input<"top" | "bottom" | "left" | "right">("left", { alias: "tooltipPosition" });

	/**
	 * The style of the tooltip.
	 */
	public style = input<"dark" | "light">("dark", { alias: "tooltipStyle" });

	/**
	 * The description of the tooltip.
	 */
	public readonly description = input("", { alias: "tooltipDescription" });

	constructor() {
		super();
		this.component.set(TooltipComponent);

		effect(() => {
			this.setComponentProperties();
		});
	}

	/**
	 * Sets the properties of the tooltip component.
	 */
	public override setComponentProperties(): void {
		if (this.componentRef === null) return;

		this.componentRef.setInput("content", this.content());
		this.componentRef.setInput("style", this.style());
		this.componentRef.setInput("description", this.description());
	}
}
